<ion-app>
  @if (isStaging) {
    <div class="staging-marker" aria-label="Invemory Staging">Staging</div>
  }
  <ion-router-outlet [animated]="false" ngSkipHydration></ion-router-outlet>
  <sm-app-update-progress></sm-app-update-progress>
  <sm-confirmation-dialog-host></sm-confirmation-dialog-host>
  <sm-server-error-dialog-host [compatibilityState]="compatibilityState"></sm-server-error-dialog-host>
  <sm-web-version-hint [blocked]="compatibilityBlocked || showAnalyticsConsentDialog"></sm-web-version-hint>

  <sm-confirmation-dialog
    class="analytics-consent-dialog"
    [isOpen]="showAnalyticsConsentDialog"
    [title]="analyticsConsentTranslationPrefix + '.title' | translate"
    [description]="analyticsConsentTranslationPrefix + '.description' | translate"
    [confirmationText]="''"
    [cancelLabel]="analyticsConsentTranslationPrefix + '.decline' | translate"
    [confirmLabel]="analyticsConsentTranslationPrefix + '.allow' | translate"
    [closeLabel]="analyticsConsentTranslationPrefix + '.decline' | translate"
    [backdropDismiss]="false"
    [busy]="analyticsConsentBusy"
    [confirmTone]="'primary'"
    [contentAlign]="'center'"
    [actionsAlign]="'center'"
    [panelVariant]="'wide'"
    [dialogType]="'information'"
    [heroIconName]="'analytics-outline'"
    (cancelRequest)="chooseAnalyticsConsent(false)"
    (confirmRequest)="chooseAnalyticsConsent(true)">
    <p class="analytics-consent__details">{{ analyticsConsentTranslationPrefix + '.details' | translate }}</p>
    <button class="analytics-consent__privacy" type="button" (click)="openAnalyticsPrivacyPolicy()">
      {{ analyticsConsentTranslationPrefix + '.privacyPolicy' | translate }}
    </button>
  </sm-confirmation-dialog>
</ion-app>
